import { SET_KEEP_SESSION } from 'constants/ui';

export const setKeepSession = (keepSession: boolean) => ({
  type: SET_KEEP_SESSION,
  payload: { keepSession },
});
